<template>
	<div class="control">
		<multiselect
			track-by="id"
			:custom-label="fieldLabel"
			:options="users"
			:placeholder="placeholder"
			:value="user"
			:searchable="true"
			deselect-label="Press enter to clear"
			:class="{ error: error }"
			@input="input"
		/>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { orderBy } from "lodash";

export default {
	name: "FieldUserSelect",
	components: { Multiselect },
	props: {
		options: {
			type: Array,
			required: true
		},
		placeholder: {
			type: String,
			default: () => "Please select"
		},
		preSelect: {
			type: Number,
			default: () => null
		},
		error: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			selected: 0
		};
	},
	computed: {
		user() {
			return this.options.find((o) => o.id === this.selected);
		},
		users() {
			return orderBy(this.options, ["firstname"], ["asc"]);
		}
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		},
		preSelect(value) {
			this.selected = value;
		}
	},
	created() {
		if (this.preSelect) {
			this.selected = this.preSelect;
		}
	},
	methods: {
		fieldLabel: ({ firstname, lastname }) => `${firstname} ${lastname}`,
		input(user) {
			this.selected = user ? user.id : 0;
		}
	}
};
</script>

<style lang="scss">
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.multiselect.error {
	.multiselect__tags {
		border: 1px solid red;
	}
}
</style>
